/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
import { ApiInfo, IEnvironment } from 'projects/shared/services/environment.interface';
// import 'zone.js/plugins/zone-error'; // Included with Angular CLI.

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const apiInfo = new ApiInfo();
apiInfo.apiBaseUrl = "https://core-api.lodasoft.dev";
apiInfo.publicApiBaseUrl = 'https://core-publicapi.lodasoft.dev';
apiInfo.docApiBaseUrl = 'https://core-docapi.lodasoft.dev';
apiInfo.authApiBaseUrl = 'https://core-api.lodasoft.dev';

export const environment: IEnvironment = {
  production: true,
  enableDebugTools: false,
  environment: 'loda-dv',
  logLevel: 'debug',
  apiInfo,
  clientRoot: "",
  companyLogoUrl: "https://core-api.lodasoft.dev/company/oa3/logo/",
  branchLogoUrl: "https://core-api.lodasoft.dev/branch/oa3/logo/",
  dnsBasedBranchLogoUrl: "https://core-api.lodasoft.dev/company/br/logo",
  faviconUrl: "https://core-api.lodasoft.dev/company/oa3/favicon/",
  borrowerPortalLoginImageUrl: "https://core-api.lodasoft.dev/company/oa3/borrower-portal-login/",
  borrowerPortalURI: "https://core-borrowerportal.lodasoft.dev/",
  scope: "Agent",
  version: "#{BuildVersion}#",
  eSignSSORedirectUrl: "https://core-borrowerportal.lodasoft.dev/esign",
  eSignVendorRedirectUrl: "https://core-borrowerportal.lodasoft.dev/agent-portal/e-sign-vendor-confirmation"
};
